<template>
    <div>
        <div v-if="isStateAllowed">
            <div v-for="(c, i) in grouped_components.filter(comp => !comp.omit_in_composition)"
                 :key="i"
                 class="mb-2"
            >
                <form @submit.prevent="saveAll()"
                      :data-vv-scope="'properties' + i"
                >
                    <b-row>
                        <b-col>
                        <span class="font-weight-bold">
                            <b-badge variant="success"
                                     class="mr-1"
                                     style="width: 90px"
                            >
                                {{ c.cas_number }}
                            </b-badge>
                            {{ c.name }}
                        </span>
                            <span class="font-weight-bold float-right">
                            <b-badge variant="primary"
                                     style="width: 90px"
                            >
                                {{
                                    Math.round(c.final_percentage * 10000) / 10000
                                }}%
                            </b-badge>
                        </span>
                            <hr class="mt-1 mb-2">
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-form-checkbox :id="'flammable_gas_' + i"
                                             :name="'flammable_gas_' + i"
                                             v-model="c.properties.flammable_gas"
                                             :value="1"
                                             :unchecked-value="0"
                                             @change="changeCheck(c, 'flammable_gas')"
                                             class="mt-1"
                            >
                                Gas inflamable
                            </b-form-checkbox>
                            <b-form-checkbox :id="'inert_gas_' + i"
                                             :name="'inert_gas_' + i"
                                             v-model="c.properties.inert_gas"
                                             :value="1"
                                             :unchecked-value="0"
                                             @change="changeCheck(c, 'inert_gas')"
                                             class="mt-2"
                            >
                                Gas inerte
                            </b-form-checkbox>
                        </b-col>

                        <b-col md="4"
                               v-if="c.properties.flammable_gas"
                        >
                            <label :for="'tci_coefficient_' + i"
                                   class="mb-0"
                            >
                                Coeficiente Tci
                            </label>
                            <b-form-input :id="'tci_coefficient_' + i"
                                          :name="'tci_coefficient_' + i"
                                          size="sm"
                                          type="number"
                                          v-model="c.properties.tci_coefficient"
                                          data-vv-as=" "
                                          v-validate="'required|decimal:4|min_value:0|max_value:100000'"
                                          @change="setChanged(c)"
                            />
                            <span class="text-danger small"
                                  v-text="errors.first('properties' + i + '.tci_coefficient_' + i)"
                            />
                        </b-col>
                        <b-col md="4"
                               v-if="c.properties.inert_gas"
                        >
                            <label :for="'equivalence_factor_' + i"
                                   class="mb-0"
                            >
                                Factor de equivalencia (Ki)
                            </label>
                            <b-form-input :id="'equivalence_factor_' + i"
                                          :name="'equivalence_factor_' + i"
                                          size="sm"
                                          type="number"
                                          v-model="c.properties.equivalence_factor"
                                          data-vv-as=" "
                                          v-validate="'required|decimal:4|min_value:0|max_value:100000'"
                                          @change="setChanged(c)"
                            />
                            <span class="text-danger small"
                                  v-text="errors.first('properties' + i + '.equivalence_factor_' + i)"
                            />
                        </b-col>

                        <b-col md="1">
                        </b-col>
                    </b-row>
                </form>
            </div>

            <div class="p-2 mb-2">
                <b-row>
                    <b-col class="mb-0">
                        <div class="metric-card p-3">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div class="metric-icon bg-soft-success">
                                    <i class="fa fa-fire icon-success"></i>
                                </div>
                                <div class="status-badge text-uppercase">Total: {{
                                        Math.round(result() * 10000) / 10000
                                    }}
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <b-row>
                <b-col cols="12"
                       class="text-center mb-2 mt-1"
                >
                    <b-btn variant="success"
                           :disabled="!grouped_components.some(c => c.changed)"
                           size="sm"
                           @click="saveAll()"
                    >
                        <i class="fa fa-save"/>
                        <span v-if="grouped_components.some(c => c.changed)">
                        Guardar <b-badge variant="light"> {{
                                grouped_components.filter(comp => comp.changed).length
                            }}</b-badge> componente(s)
                    </span>
                        <span v-else>
                        Guardar componentes
                    </span>
                    </b-btn>
                </b-col>
            </b-row>
        </div>
        <classification :classification.sync="classification"/>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState, mapGetters} from 'vuex';
import Classification from '../../../components/classification.vue';

export default {
    name: 'index',
    components: {
        Classification,
    },
    data() {
        return {
            name: '',
            typing_timer: null,
            done_typing_interval: 500,
            saving: false
        };
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'raw_material',
            'only_view',
            'grouped_components',
            'classification'
        ]),
        ...mapGetters('calculator', ['isStateAllowed'])
    },
    async mounted() {
        await this._getClassification();
    },
    methods: {
        ...mapActions('calculator', [
            'deleteRawMaterial',
            'updateComponents',
            'getGroupedComponents',
            'getClassification',
            'updatePropertiesComponents'
        ]),
        ...mapMutations('calculator', [
            'setModalRawMaterialShow',
            'setActionRawMaterialShow',
            'setRawMaterial',
            'setModalComponentsShow',
            'setModalToxicityShow',
            'setRawMaterial',
            'setGroupedComponents'
        ]),
        async changeCheck(component, key) {
            if (key === 'flammable_gas') {
                if (component.properties.flammable_gas) {
                    component.properties.inert_gas = 0;
                    component.properties.equivalence_factor = 0;
                } else {
                    component.properties.tci_coefficient = 0;
                }
            } else {
                if (component.properties.inert_gas) {
                    component.properties.flammable_gas = 0;
                    component.properties.tci_coefficient = 0;
                } else {
                    component.properties.equivalence_factor = 0;
                }
            }

            this.setChanged(component);
        },
        async saveAll() {
            let valid = await this.validate();

            if (valid) {
                let components = this.grouped_components.filter(c => c.changed);

                await this.updatePropertiesComponents({components});

                await this._getClassification();
            }
        },
        async validate(index = 0) {
            if (index >= this.grouped_components.length) {
                return true;
            }

            let valid = true;
            let second_valid = true;
            let component = this.grouped_components[index];

            if (component.changed) {
                valid = await this.$validator.validateAll('properties' + index);
            }

            second_valid = await this.validate(index + 1);

            return valid && second_valid;
        },
        setChanged(component_product, changed = true) {
            const updatedComponents = this.grouped_components.map(gc =>
                gc.id === component_product.id ? {...gc, changed} : gc
            );
            this.setGroupedComponents(updatedComponents);
        },
        result() {
            let flammable_gases_pct = 0;
            let equivalence_factor_sum = 0;

            this.grouped_components.forEach((component) => {
                if (component.properties.flammable_gas) {
                    flammable_gases_pct += +component.final_percentage;
                } else if (component.properties.inert_gas) {
                    equivalence_factor_sum += +component.final_percentage * +component.properties.equivalence_factor;
                }
            });

            let result_step_1 = flammable_gases_pct + equivalence_factor_sum;

            if (result_step_1) {
                let result_step_2 = 100 / result_step_1;
                let result = 0;

                this.grouped_components.forEach((component) => {
                    result += component.properties.tci_coefficient
                        ? (+component.final_percentage * result_step_2 / +component.properties.tci_coefficient)
                        : 0;
                });

                return result;
            }

            return 0;
        },
        async _getClassification() {
            await this.getGroupedComponents();
            await this.getClassification({product_id: this.product.id, danger_code: 'MCAL41'});
        }
    }
};
</script>

<style>
.th-check {
    width: 35px !important;
    max-width: 35px !important;
}
</style>
